import React, { FC, useState, MouseEvent } from 'react';
import Button from '../Button';
import { Props as ButtonProps } from '../../../../BaseComponents/Button/types';
import { copyToClipboard } from '../../../../html/utils';
import { CdnIcon } from '@shared/ui';
import { useTranslation } from 'react-i18next';

interface Props extends ButtonProps {
	text: string;
	copyButtonText?: string;
	copiedButtonText?: string;
	iconPosition?: 'left' | 'right';
}

const CopyButton: FC<Props> = ({
	text,
	copyButtonText,
	copiedButtonText,
	iconPosition = 'left',
	onClick,
	...buttonProps
}) => {
	const { t } = useTranslation('');

	const [copied, setCopied] = useState(false);

	const handleCopy = async (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();

		try {
			await copyToClipboard(text);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);

			onClick?.(e);
		} catch (err) {
			console.error('Ошибка при копировании: ', err);
		}
	};

	const icon = <CdnIcon icon={copied ? 'Info/Check' : 'Action/Copy'} />;

	const startIcon = iconPosition === 'left' ? icon : null;
	const endIcon = iconPosition === 'right' ? icon : null;

	const copyText = copyButtonText || t('Copy');
	const copiedText = copiedButtonText || t('Copied!');

	return (
		<Button onClick={handleCopy} startIcon={startIcon} endIcon={endIcon} {...buttonProps}>
			{copied ? copiedText : copyText}
		</Button>
	);
};

export default CopyButton;
